
import React from 'react';
import OfferPageDetailView from './OfferPageDetailView';

interface OfferPageDetailsViewProps {
  id: string;
  onClose: () => void;
}

const OfferPageDetailsView: React.FC<OfferPageDetailsViewProps> = ({ id, onClose }) => {
  return <OfferPageDetailView id={id} onClose={onClose} />;
};

export default OfferPageDetailsView;
